import React from "react";
import { useTranslation } from "../../hooks/useTranslation";
import { MEDIA_URL } from "../../config/constants";

const StoryTimeline = () => {
  const { t } = useTranslation('about');
  const timelineData = t('story.timeline', { returnObjects: true });

  const timelineEvents = [
    {
      ...timelineData[0],
      image: `${MEDIA_URL}/images/about/Our Story/Trip in Croatia.webp`,
      position: "right",
    },
    {
      ...timelineData[1],
      image: `${MEDIA_URL}/images/about/Our Story/Sun Catchers was born 2.webp`,
      position: "left",
    },
    {
      ...timelineData[2],
      image: `${MEDIA_URL}/images/about/Our Story/First Campervan.webp`,
      position: "right",
    },
    {
      ...timelineData[3],
      image: `${MEDIA_URL}/images/about/Our Story/First customer.webp`,
      position: "left",
    },
    {
      ...timelineData[4],
      image: `${MEDIA_URL}/images/WAVE%20CATCHER/WaveCatcher0002.webp`,
      position: "right",
      upcoming: true,
    },
    {
      ...timelineData[5],
      image: `${MEDIA_URL}/images/about/feature-placeholder.webp`,
      position: "left",
      upcoming: true,
    },
  ];

  return (
    <section className="story-section">
      <div className="story-container">
        <div className="story-header">
          <h2 className="story-title">{t('story.title')}</h2>
          <p className="story-description">
            {t('story.description')}
          </p>
        </div>
        <div className="timeline">
          {timelineEvents.map((event, index) => (
            <div
              key={index}
              className={`timeline-event ${event.position} ${event.upcoming ? "upcoming" : ""}`}
            >
              <div className="timeline-content">
                <div className="timeline-date">
                  <span className="date-text">{event.date}</span>
                  {event.upcoming && <span className="soon-badge">{t('story.soonBadge')}</span>}
                </div>
                <div className="timeline-details">
                  <h3 className="timeline-event-title">{event.title}</h3>
                  <p className="timeline-event-description">
                    {event.description}
                  </p>
                </div>
              </div>
              <div className="timeline-marker"></div>
              <img
                src={event.image}
                alt={event.title}
                className="timeline-image"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StoryTimeline;
